import { Quote } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";

const TESTIMONIALS = [
    {
        quote: "Poznałam eduNation dzięki akcji z bezpłatnymi webinariami i przepadłam! Tyle wiedzy i konkretnych informacji gdzie, co i jak — jednym słowem: PERFECT! Dziękuję Wam za bombę wiedzy i kopy motywacji!",
        author: "Kamila K.",
    },
    {
        quote: "Korzystam z webinariów, kupuję kursy, oglądam, uczę się i często wracam do obejrzanych materiałów. Idealnie odpowiadają moim potrzebom jako nauczycielki i przedsiębiorcy w branży edukacji. Gorąco polecam!",
        author: "Katarzyna K.",
    },
    {
        quote: "Zawsze wysoki poziom szkoleń płatnych i bezpłatnych. W każdym znajdziesz gotowe pomysły, od razu do wdrożenia na Twoich lekcjach.",
        author: "Katarzyna P.",
    },
    {
        quote: "Wasze tematy z edunation wykorzystuję na zajęciach! To miło słyszeć, jak uczniowie mówią: „Ale ta lekcja była faaajna!”. DZIĘKUJĘ!",
        author: "Iwona S.",
    },
    {
        quote: "Każde szkolenie z eduNation to mnóstwo niesamowitych inspiracji, świetnie przekazana wiedza i duża dawka motywacji. Trenerzy zawsze doskonale przygotowani. Serdecznie polecam wszystkim, którzy chcą się rozwijać.",
        author: "Iwona L.",
    },
    {
        quote: "Znaczącą część tego, co umiem i jaką jestem nauczycielką, wiem od Ani i Luizy. To praca na najwyższym poziomie — gratuluję kreatywności, odwagi i pasji. Robicie genialną robotę! Brawa!",
        author: "Jolanta L.",
    },
];

const Card = ({ t, i, testid }) => (
    <figure
        data-testid={testid || `testimonial-card-${i + 1}`}
        className="w-[19rem] sm:w-[22rem] shrink-0 rounded-3xl bg-white border border-brand-tint2 p-7 shadow-[0_16px_40px_-24px_rgba(194,24,91,0.4)]"
    >
        <Quote className="w-7 h-7 text-brand" aria-hidden="true" />
        <blockquote className="mt-4 text-base sm:text-lg leading-relaxed text-brand-ink font-medium italic">
            „{t.quote}"
        </blockquote>
        <figcaption className="mt-5 font-mono text-xs tracking-[0.16em] uppercase text-brand-gray">
            — {t.author}
        </figcaption>
    </figure>
);

export default function Testimonials() {
    return (
        <section className="py-16 sm:py-24 overflow-hidden" data-testid="testimonials-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-8">
                <SectionHead
                    index="05"
                    label="Opinie nauczycieli"
                    title="Co mówią uczestnicy naszych webinarów?"
                    center
                />
            </div>
            <Reveal delay={0.15}>
                <div
                    className="marquee-hover relative mt-12 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]"
                    data-testid="testimonials-marquee"
                >
                    <div className="animate-marquee flex gap-6 w-max px-6">
                        {TESTIMONIALS.map((t, i) => (
                            <Card key={`a-${i}`} t={t} i={i} />
                        ))}
                        {TESTIMONIALS.map((t, i) => (
                            <Card key={`b-${i}`} t={t} i={i} testid={`testimonial-card-dup-${i + 1}`} />
                        ))}
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
